import axios from "axios";

import appConfig from "../config";

export async function loginWithPassword(email: string, password: string) {
  return axios.get(`${appConfig.apiUrl}/login/password`, {
    headers: {
      Authorization: `Basic ${btoa(`${email}:${password}`)}`,
    },
    withCredentials: true,
  });
}

export async function loginPasswordlessRequest(email: string) {
  return axios.post(
    `${appConfig.apiUrl}/login/passwordless/send`,
    {
      destination: email,
    },
    { headers: { "Content-Type": "application/json" } }
  );
}

export async function loginPasswordless(token: string) {
  return axios.get(`${appConfig.apiUrl}/login/passwordless`, {
    params: { token },
    withCredentials: true,
  });
}
